// extracted by mini-css-extract-plugin
export default {"Coconut":"#F4F7FA","White":"#FFFFFF","pageContainer":"G720773","headerContainer":"Gad0d15"};